import React from 'react';

import { ComponentIconProps } from '../types';

const NotificationCloseIcon: React.FC<ComponentIconProps> = ({
  size = 16,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path d="M13.3996 3.40001L12.5996 2.60001L7.99961 7.30001L3.39961 2.60001L2.59961 3.40001L7.29961 8.00001L2.59961 12.6L3.39961 13.4L7.99961 8.70001L12.5996 13.4L13.3996 12.6L8.69961 8.00001L13.3996 3.40001Z" />
  </svg>
);

export default NotificationCloseIcon;
